import React from 'react';
import { motion } from 'framer-motion';
type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'accent';
type ButtonSize = 'sm' | 'md' | 'lg';
type ButtonProps = {
  children: ReactNode;
  variant?: ButtonVariant;
  size?: ButtonSize;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'button' | 'submit';
};
const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-emerald-500 hover:bg-emerald-400 text-gray-900 font-semibold',
  secondary: 'bg-gray-800 hover:bg-gray-700 text-gray-100 border border-gray-700',
  ghost: 'bg-transparent hover:bg-gray-800 text-gray-300',
  accent: 'bg-amber-500 hover:bg-amber-400 text-gray-900 font-semibold'
};
const sizeStyles: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-5 py-2.5 text-sm',
  lg: 'px-8 py-3.5 text-base'
};
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  disabled = false,
  className = '',
  type = 'button'
}: ButtonProps) {
  return <motion.button type={type} onClick={onClick} disabled={disabled} whileHover={{
    scale: disabled ? 1 : 1.02
  }} whileTap={{
    scale: disabled ? 1 : 0.98
  }} className={`
        ${variantStyles[variant]}
        ${sizeStyles[size]}
        rounded-lg transition-colors duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-gray-900
        ${className}
      `} data-id="element-254">
      {children}
    </motion.button>;
}